module.exports = __webpack_public_path__ + "media/photo/electric_man-a971d43b.jpg";